export function useCSVUtil() {
  return {
    /** Triggers a browser download of an already-built CSV string (e.g. the raw
     * text/csv body returned by a generated `export{Resource}{Mode}SearchToCsv()`
     * endpoint), without re-building it row-by-row like [generateCSV] does. */
    downloadCSVString(csvString: string, fileName: string = "data.csv"): void {
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    generateCSV<T extends Record<string, any>>(
      data: T[],
      fileName: string = "data.csv",
      headersProvided:
        | { title: string; value: string }[]
        | undefined = undefined,
    ): void {
      if (!data || !data.length) {
        console.warn("No data provided");
        return;
      }

      const headers =
        headersProvided ||
        Object.keys(data[0]).map((h: string) => ({ title: h, value: h }));
      const csvRows: string[] = [];

      // Add the header row
      csvRows.push(headers.map((h) => h.title).join(","));

      // Add data rows
      for (const row of data) {
        const values = headers.map((header) => {
          const val = row[header.value];
          // Escape double quotes and wrap in quotes if needed
          if (typeof val === "string") {
            return `"${val.replace(/"/g, '""')}"`;
          } else if (val == null) {
            return "";
          }
          return val.toString();
        });
        csvRows.push(values.join(","));
      }

      const csvString = csvRows.join("\n");
      this.downloadCSVString(csvString, fileName);
    },
  };
}
